/**
 * Canonical invoice / PO number for production orders (numeric sequence from counters/orderNumber).
 * Quote-style IDs (e.g. Q2026-001) live on quote.quoteNumber and order.quoteNumber for reference only.
 */
export function resolveOrderPoNumber(order) {
  if (!order) return null;

  const po = order.poNumber;
  if (po != null && po !== '') {
    if (typeof po === 'number' && Number.isFinite(po)) return po;
    const parsed = parseInt(String(po).replace(/\D/g, ''), 10);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }

  return null;
}

export function formatOrderPoNumber(order, fallback = 'N/A') {
  const po = resolveOrderPoNumber(order);
  if (po != null) return String(po);
  if (order?.orderNumber) return String(order.orderNumber);
  if (order?.id) return order.id.slice(0, 8);
  return fallback;
}

export function buildQuoteConversionNotes(quote) {
  const parts = [];
  if (quote?.notes?.trim()) parts.push(quote.notes.trim());
  if (quote?.quoteNumber) {
    parts.push(`Converted from quote ${quote.quoteNumber}`);
  }
  return parts.join('\n\n');
}
